export default __webpack_public_path__ + "static/media/map-boston-small.1a260a34.jpg";